import { render, staticRenderFns } from "./EvidenciaBHP.vue?vue&type=template&id=03161e13&scoped=true&"
import script from "./EvidenciaBHP.vue?vue&type=script&lang=ts&"
export * from "./EvidenciaBHP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03161e13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('03161e13', component.options)
    } else {
      api.reload('03161e13', component.options)
    }
    module.hot.accept("./EvidenciaBHP.vue?vue&type=template&id=03161e13&scoped=true&", function () {
      api.rerender('03161e13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EvidenciaBHP/EvidenciaBHP.vue"
export default component.exports